import {
    CLIENT_LIST,
    CLIENT_LIST_PROGRESS
} from '../actions/getClientListAction';
// import { REHYDRATE } from 'redux-persist';

export default (state={},action)=>{
    switch(action.type){
        // case REHYDRATE:
        //  return {
        // ...state,
        // user: action.payload && action.payload.user
        // };
        case CLIENT_LIST_PROGRESS:
                return true;
        case CLIENT_LIST:
        return action.data
        default:
        return state;
    }
}